export * from "./patient.reducer";
export * from "./test-order.reducer";
export * from "./patient-search.reducer";
export * from "./test-order-search.reducer";
export * from "./phlebotomist-search.reducer";
export * from "./office-staff-search.reducer";
export * from "./office-staff.reducer";
export * from "./test-selection-session.reducer";
export * from "./code-selection-session.reducer";
export * from "./location-search.reducer";
export * from "./location.reducer";
export * from "./patient-reg.reducer";
export * from "./patient-test-results.reducer";



// WEBPACK FOOTER //
// ./src/app/shared/reducers/index.ts